import WebsiteConfigurations from "Pages/AccountSetting/InvesterWebsite/WebsiteConfigurations";
import { useAppSelector } from "store/store";
import AboutMeForm from "./AboutMeForm";
import BasketForm from "./BasketForm";
import ComplainResolutionForm from "./ComplainResolutionForm";
import ComplianceAuditReportForm from "./ComplianceAuditReportForm";
import DisclosureForm from "./DisclosureForm";
import FaqsForm from "./FaqsForm";
import FooterForm from "./FooterForm";
import GrievanceComplianceOfficerDetailsForm from "./GrievanceComplianceOfficerDetailsForm";
import HeroSectionForm from "./HeroSectionForm";
import InvestmentCharterForm from "./InvestmentCharterForm";
import MyBrandingForm from "./MyBrandingForm";
import PerformanceMetricsForm from "./PerformanceMetricsForm";
import PoliciesForm from "./PoliciesForm";
import QuoteForm from "./QuoteForm";
import TermsConditionsForm from "./TermsConditionsForm";
import TestimonialsForm from "./TestimonialsForm";

const WebsiteForm = () => {
  const { selectedSection, openExtraSection } = useAppSelector(
    (state) => state?.myWebsite,
  );

  switch (selectedSection || openExtraSection) {
    case "MY_BRANDING":
      return <MyBrandingForm />;
    case "HERO_SECTION":
      return <HeroSectionForm />;
    case "PERFORMANCE_METRICS":
      return <PerformanceMetricsForm />;
    case "QUOTE_MANTRA":
      return <QuoteForm />;
    case "MY_BASKETS":
      return <BasketForm />;
    case "ABOUT_ME":
      return <AboutMeForm />;
    case "TESTIMONIALS":
      return <TestimonialsForm />;
    case "FAQS":
      return <FaqsForm />;
    case "FOOTER":
      return <FooterForm />;
    case "WEBSITE_CONFIGURATION":
      return <WebsiteConfigurations />;
    case "INVESTMENT_CHARTER":
      return <InvestmentCharterForm />;
    case "TERMS_CONDITIONS":
      return <TermsConditionsForm />;
    case "POLICIES":
      return <PoliciesForm />;
    case "DISCLOSURE":
      return <DisclosureForm />;
    case "COMPLIANCE_AUDIT_REPORT":
      return <ComplianceAuditReportForm />;
    case "COMPLAINTS_RESOLUTION":
      return <ComplainResolutionForm />;
    case "GRIEVANCE_COMPLIANCE_OFFICER_DETAILS":
      return <GrievanceComplianceOfficerDetailsForm />;

    default:
      return <div>WebsiteForm</div>;
  }
};

export default WebsiteForm;
